export default (state = 0, action) => {
    if (action.type === 'FETCH_ITEMS') {
        return action.payload.totalCount;
    }

    return state;
}